module.exports = "/_next/static/images/title-ea80954e.png";